import React from "react";

export const AccountLayout = (props) => {
    
    return (
        <div className="container">
            {props.children}
        </div>
    );
};